<template>
  <div class="container">
    <div class="row">
      <div class="text--base">
        <Firms :content="firmsContent" />
      </div>
    </div>
  </div>
</template>

<script>
import { json as fetchJson } from 'd3';
import Firms from '@/components/content/Firms.vue';

export default {
  name: 'App2BubbleGrid',
  components: {
    Firms,
  },
  data() {
    return {
      content: {},
    };
  },
  computed: {
    firmsContent() {
      return this.content.sections ? this.content.sections.find((d) => d.id === 'firms') : {};
    },
  },
  async created() {
    this.content = await fetchJson(`${process.env.BASE_URL}data/content/chapter-01.json`);
  },
};
</script>

<style scoped>
.container {
  background-color: #f4f6fd;
}
</style>